import { inject, Pipe, PipeTransform } from '@angular/core';
import { StringTransformationService } from '../services/transformation-helper/string-transformation.service';

@Pipe({
  name: 'truncate',
  standalone: false,
})
export class TruncatePipe implements PipeTransform {
  private readonly stringTransformation = inject(StringTransformationService);

  transform(value: string, limit = 25, completeWords = false, ellipsis = '...') {
    const valueStr = this.stringTransformation.escapeHtml(value);
    if (value) {
      if (completeWords) {
        limit = value.substring(0, limit).lastIndexOf(' ');
      }
      if (value.length > limit) {
        return '<span title="' + valueStr + '">' + value.substring(0, limit) + ellipsis + '</span>';
      } else {
        return value;
      }
    } else {
      return value;
    }
  }
}
